export default {  
    methods: {
        loginStart() {
            window.dataLayer.push({
                "event": "login",                
                "event_name": "login_start",
                "platform": "web"
            })
        },
        loginFinish() {
            window.dataLayer.push({
                "event": "login",                
                "event_name": "login_finish",
                "platform": "web"
            })
        },
        loginError(error) {
            window.dataLayer.push({
                "event": "login",                
                "event_name": "login_error",
                "platform": "web",
                "error_type": error
            })
        },
        logoutStart() {
            window.dataLayer.push({
                "event": "logout",                
                "event_name": "logout_start",
                "platform": "web"
            })
        },     
        logoutFinish() {
            window.dataLayer.push({
                "event": "logout",                
                "event_name": "logout_finish",
                "platform": "web"
            })
        },    
        myAccount() {
            window.dataLayer.push({
                "event": "my_account",                
                "event_name": "my_account_zone",
                "platform": "web"
            })
        },
        subAccountCreate(subAccount, subAccountAge) {
            window.dataLayer.push({
                "event": "my_account",                
                "event_name": "my_account_subaccount_create",
                "platform": "web",
                "sub_account": subAccount,
                "sub_account_age": subAccountAge
            })
        },
        navigationEvent(section) {
            window.dataLayer.push({
                "event": "navigation",                
                "event_name": "category",
                "platform": "web",
                "section": section
            })
        },
        searchEvent(searchQuery, results) {
            window.dataLayer.push({
                "event": "search",                
                "event_name": "search",
                "platform": "web",
                "search_term": searchQuery,
                "results": results
            })
        },       
        gameStart(nameOfGame, categoryGame) {
            window.dataLayer.push({
                "event": "game",                
                "event_name": "game_start",
                "name": nameOfGame,
                "platform": "web",
                "main_category": categoryGame
            })
        },      
        addToFavourite(nameOfFavourite, categoryOfFavourite){
            window.dataLayer.push({
                "event": "add_to_favourites",                
                "event_name": "add_to_favourites",
                "platform": "web",
                // nazwa wideo programu, gry lub muzyki
                "name": nameOfFavourite,
                "main_category": categoryOfFavourite
            })
        },
        videoDetails(idVideo, mainCategory, nameVideo, subCategory, episode) {
            window.dataLayer.push({
                "event": "video",
                "event_name": "video_details",    
                "id": idVideo, //id oglądanego wideo z feedu produktowego
                "main_category": mainCategory, //główna kategoria 
                "name": nameVideo, //nazwa wideo programu
                "sub_category": subCategory, //numer stworzonego profilu dziecka (subkonta)
                "episode": episode, //numer odcinka
             });
        },
        myAccountFunction(accountFunction) {
            window.dataLayer.push({
                "event": "my_account",
                "event_name": "my_account_function",
                "platform": "web",
                "function": accountFunction
               });
        }
    }
}
